<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-row">
      <div v-if="isCreate" class="col-sm form-group">
        <label for="_email" class="control-label">{{ $t('user.field.email') }}</label>
        <b-form-input
          v-model="item.email"
          type="text"
          required
          id="_email"
          :state="(errors && errors.email)?false:null"
        />
        <b-form-invalid-feedback
          v-if="errors && errors.email"
          id="_email_helpBlock"
        >{{ errors.email }}</b-form-invalid-feedback>
      </div>
      <div class="col-sm form-group">
        <label for="_password" class="control-label">{{ $t('user.field.password') }}</label>
        <b-form-input
          v-model="item.password"
          type="password"
          :required="isCreate"
          id="_password"
          :state="(errors && errors.password)?false:null"
        />
        <b-form-invalid-feedback
          v-if="errors && errors.password"
          class="help-block invalid-feedback"
          id="_password_helpBlock"
        >{{ errors.password }}</b-form-invalid-feedback>
      </div>
    </div>
    <div class="form-row">
      <div class="col-sm form-group">
        <label for="_alias" class="control-label">{{ $t('user.field.alias') }}</label>
        <b-form-input
          v-model="item.alias"
          type="text"
          id="_alias"
          :state="(errors && errors.alias)?false:null"
        />
        <b-form-invalid-feedback
          v-if="errors && errors.alias"
          class="help-block invalid-feedback"
          id="_alias_helpBlock"
        >{{ errors.alias }}</b-form-invalid-feedback>
      </div>
      <div v-if="isCreate" class="col-sm form-group">
        <label for="_maritalStatus" class="control-label">{{ $t('user.field.maritalStatus') }}</label>
        <b-form-select
          v-model.number="item.maritalStatus"
          required
          id="_maritalStatus"
          :state="(errors && errors.maritalStatus)?false:null"
        >
          <option></option>
          <option value="1">{{ $t('user.field.maritalStatusOptions.singleMale') }}</option>
          <option value="2">{{ $t('user.field.maritalStatusOptions.singleFemale') }}</option>
          <option value="3">{{ $t('user.field.maritalStatusOptions.couple') }}</option>
        </b-form-select>
        <b-form-invalid-feedback
          v-if="errors && errors.maritalStatus"
          class="help-block invalid-feedback"
          id="_maritalStatus_helpBlock"
        >{{ errors.maritalStatus }}</b-form-invalid-feedback>
      </div>
    </div>
    <div class="form-row">
      <div v-if="isCreate && item.maritalStatus !== 2" class="col-sm form-group">
        <label for="_maleBirthYear" class="control-label">{{ $t('user.field.maleBirthYear') }}</label>
        <b-form-input
          type="number"
          name="_maleBirthYear"
          id="_maleBirthYear"
          v-model.number="item.maleBirthYear"
          :state="(errors && errors.maleBirthYear)?false:null"
          required
        />
        <b-form-invalid-feedback
          v-if="errors && errors.maleBirthYear"
          class="help-block invalid-feedback"
          id="_maleBirthYear_helpBlock"
        >{{ errors.maleBirthYear }}</b-form-invalid-feedback>
      </div>
      <div v-if="isCreate && item.maritalStatus !== 1" class="col-sm form-group">
        <label for="_femaleBirthYear" class="control-label">{{ $t('user.field.femaleBirthYear') }}</label>
        <b-form-input
          type="number"
          name="_femaleBirthYear"
          id="_femaleBirthYear"
          v-model.number="item.femaleBirthYear"
          :state="(errors && errors.femaleBirthYear)?false:null"
          required
        />
        <b-form-invalid-feedback
          v-if="errors && errors.femaleBirthYear"
          class="help-block invalid-feedback"
          id="_femaleBirthYear_helpBlock"
        >{{ errors.femaleBirthYear }}</b-form-invalid-feedback>
      </div>
    </div>
    <div class="form-group">
      <label for="_language" class="control-label">{{ $t('user.field.language') }}</label>
      <b-form-select
        name="_language"
        id="_language"
        required
        v-model="item.language"
        :state="(errors && errors.language)?false:null"
      >
        <option></option>
        <option value="fr_FR">French - France</option>
<!--        <option value="en_US">English - United States</option>-->
      </b-form-select>
      <b-form-invalid-feedback
        v-if="errors && errors.language"
        class="help-block invalid-feedback"
        id="_language_helpBlock"
      >{{ errors.language }}</b-form-invalid-feedback>
    </div>
        <img
          class="float-right"
          src="../../assets/ESRB_Adults_Only_18+.svg"
          alt="ESRB adult only"
          width="64px"
        >
    <div class="form-row">
      <div class="col-sm form-group">
        <b-form-checkbox
          v-model="item.acceptNotifications"
          :state="(errors && errors.acceptNotifications)?false:null"
        >{{ $t('user.field.acceptNotifications') }}</b-form-checkbox>
        <b-form-invalid-feedback
          v-if="errors && errors.acceptNotifications"
          class="help-block invalid-feedback"
        >{{ errors.acceptNotifications }}</b-form-invalid-feedback>
      </div>
      <!-- <div v-if="isCreate" class="col-sm form-group">
        <b-form-checkbox
          tag="b-form-checkbox"
          v-model="isAdult"
          required
          :state="(errors && errors.tosAccept)?false:null"
        >{{ $t('user.field.isAdult') }}</b-form-checkbox>
      </div> -->
    </div>
    <div class="mt-4 mb-2 form-group">
      <b-form-checkbox
        v-if="isCreate"
        required
      >{{ $t('user.field.isAdult') }}</b-form-checkbox>
    </div>
    <div class="mt-4 mb-2">
      <b-form-checkbox
          v-if="isCreate"
          v-model="item.tosAccept"
          :state="(errors && errors.tosAccept)?false:null"
        >{{ $t('user.field.tosAccept') }}</b-form-checkbox>
    </div>
    <TOS v-if="isCreate && !item.tosAccept" id="tos"></TOS>
    <div class="text-center">
      <button type="submit" @click="item.tosAccept = true" class="btn btn-primary mb-3" id="submit">{{ $t('global.form.submit') }}</button>
    </div>
  </form>
</template>
<script>
import TOS from "../app/TOS.vue";

export default {
  data: function() {
    return {
      // isAdult: false,
      tosNotRead: true
    };
  },
  components: { TOS },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    isCreate: false,
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    initialValues: {
      type: Object
    }
  },
  computed: {
    item: function() {
      return this.initialValues ? this.initialValues : this.values;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/Form.vue